<style>
.lt-params-component-card {
  margin: 10px 0px;
}

.lt-params-component-elements {
  padding: 15px;
}
.lt-params-component-name {
  padding-top: 25px;
}

.lt-params-component-switch {
  justify-content: center;
}

.lt-params-component-text-field {
  padding: 10px 10px 0px 10px;
}

.lt-params-component-select {
  padding: 10px 10px 0px 10px;
}
</style>

<template>
  <div>
    <v-card class="lt-params-component-card">
      <v-container
        fluid
        grid-list-md
        class="lt-params-component-elements"
      >
        <v-layout wrap>
          <v-flex
            d-flex
            xs12
            sm2
            md2
          >
            <div class="lt-params-component-name">
              {{ Parameter.parameterName }}
            </div>
          </v-flex>
          <v-flex
            d-flex
            xs12
            sm4
            md4
          >
            <v-text-field
              class="lt-params-component-text-field"
              v-model="labelName"
              label="Label"
              :error-messages="labelNameErrors"
              @blur="$v.labelName.$touch()"
            >
            </v-text-field>
          </v-flex>
          <v-flex
            d-flex
            xs12
            sm4
            md4
          >
            <v-select
              class="lt-params-component-select"
              v-model="Widget"
              label="Widgets"
              :items="Widgets"
              item-text="Name"
              item-value="Id"
              :error-messages="WidgetErrors"
              @blur="$v.Widget.$touch()"
            >
            </v-select>
          </v-flex>
          <v-flex
            d-flex
            xs12
            sm2
            md2
          >
            <v-switch
              label="Obbligatorio"
              color="#5c6366"
              v-model="Obbligatorio"
              class="lt-params-component-switch"
            >
            </v-switch>
          </v-flex>
        </v-layout>

      </v-container>
    </v-card>
  </div>
</template>

<script>
import widgetsApi from "../../src/apiLogisticsTool/widgetsApi.js";
import proceduresParametersApi from "../../src/apiLogisticsTool/procedureParametersApi.js";
import proceduresApi from "../apiLogisticsTool/proceduresApi";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  validations: {
    labelName: { required },
    Widget: { required }
  },

  props: {
    // ParameterName: String,
    // LabelName: String,
    // WidgetSelect: Number,
    // Obbligatorio: Boolean
    Parameter: Object,
    spId: String,
    ProcedureName: String
  },

  computed: {
    labelNameErrors() {
      const errors = [];
      if (!this.$v.labelName.$dirty) return errors;
      !this.$v.labelName.required &&
        errors.push("Inserire il nome del parametro");
      return errors;
    },
    WidgetErrors() {
      const errors = [];
      if (!this.$v.Widget.$dirty) return errors;
      !this.$v.Widget.required && errors.push("Selezionare il Widget");
      return errors;
    }
  },

  data: () => ({
    Widget: "",
    Widgets: [],
    ObjectToPass: {
      ParameterName: "",
      LabelName: "",
      WidgetSelect: "",
      Obbligatorio: ""
    },
    Label: "",
    Obbligatorio: false,
    labelName: "",
    dataFromProcedureParameters: []
  }),

  created() {
    //estraggo l'elenco dei widgets
    widgetsApi.GetWidgets().then(response => {
      this.Widgets = response.data;
      // this.Widget = this.Widgets.filter(x => x.Name == "Textbox")[0].Id;
      console.log(this.Widget);
      console.log(this.Parameter);
    });
    var id = this.$route.params.Id;

    if (id) {
      proceduresParametersApi
        .GetProceduresParametersByIdAndName(
          this.spId,
          this.Parameter.parameterName
        )
        .then(response => {
          this.dataFromProcedureParameters = response.data;
          this.autocomplete(this.dataFromProcedureParameters);
        });
    } else {
      proceduresApi.GetInfromationParameters(this.Parameter.parameterName);
    }
    //se non c'è l'id devo fare la chiamata per sapere ParameterDatatype, ParameterLenght
    //GetInfromationParameters
  },

  methods: {
    autocomplete(data) {
      for (var i = 0; i < data.length; i++) {
        (this.Widget = data[i].widgetId),
          (this.labelName = data[i].label),
          (this.Obbligatorio = data[i].isRequired);
      }
    },

    passData() {
      this.ObjectToPass = {
        ParameterName: this.Parameter.parameterName,
        Label: this.labelName,
        WidgetId: this.Widget,
        IsRequired: this.Obbligatorio,
        Id: this.Parameter.id,
        ParameterLenght: this.Parameter.characteR_MAXIMUM_LENGTH,
        ParameterDataType: this.Parameter.datA_TYPE
      };

      return this.ObjectToPass;
    },

    getLabelName() {},

    validate: function(value) {
      this.$v.$touch();
    }
  }
};
</script>
